import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Result,
  Typography,
} from 'antd';
import { NODE_ENV } from 'utils/env';

const { Text } = Typography;

const SomethingWentWrong = ({ error }) => (
  <div style={{
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  }}
  >
    <Result
      status="500"
      title="Ooops"
      subTitle="Algo salió mal"
    />
    <Text>Intenta</Text>
    <Button
      type="link"
      onClick={() => window?.location?.reload()}
    >
      Recargar la página
    </Button>
    <Text>o</Text>
    <Button
      type="link"
    >
      Contacta supporte
    </Button>
    <br />
    {NODE_ENV !== 'production' && <center><span>{error.toString()}</span></center>}
  </div>
);

SomethingWentWrong.propTypes = {
  error: PropTypes.string,
};

SomethingWentWrong.defaultProps = {
  error: null,
};

export default SomethingWentWrong;
